<template>
  <div class="user-info-modal d-flex justify-center align-center">
    <div class="user-info-box">
      <div class="page-title">Profile Info</div>

      <div class="d-flex flex-field">
        <div :class="['pax-field', {'has-error':error.fields.indexOf('title') > -1}]">
          <select v-model="title" :class="['pax-bday', {'has-error':error.fields.indexOf('title') > -1}]" :disabled="loading">
            <option value="">--</option>
            <option value="Mr">Mr.</option>
            <option value="Ms">Ms.</option>
            <option value="Mrs">Mrs.</option>
            <option value="Miss">Miss</option>
            <option value="Mstr">Mstr</option>
          </select>
        </div>
        <div :class="['pax-field', {'has-error':error.fields.indexOf('gender') > -1}]">
          <select v-model="gender" :class="['pax-bday', {'has-error':error.fields.indexOf('gender') > -1}]" :disabled="loading">
            <option value="">--</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>
      </div>
      <div class="d-flex flex-field">
        <div :class="['pax-field', {'has-error':error.fields.indexOf('firstName') > -1}]">
          <input type="text" placeholder="First Name" v-model="firstName" 
            autocomplete="one-time-code" :disabled="loading" />
        </div>
        <div :class="['pax-field', {'has-error':error.fields.indexOf('lastName') > -1}]">
          <input type="text" placeholder="Last Name" v-model="lastName" 
            autocomplete="one-time-code" :disabled="loading" />
        </div>
      </div>
      <div class="pax-field">
        <mobile-input :mobile="mobile" :uniqID="'mobile4'" @verified="mobileVerified"
          @updateMobile="updateMobileInfo" ref="userMobile" :dialCode="countryCode"
          :required="true" :hasError="error.fields.indexOf('mobile') > -1"
          :needVerification="!isCorporate"></mobile-input>
      </div>
      <div class="pax-field d-flex justify-space-between flex-field">
        <select v-model="birthMonth" :class="['pax-bday', {'has-error':error.fields.indexOf('birthMonth') > -1}]" :disabled="loading">
          <option value="" disabled selected>Birth Month</option>
          <option value="01">Jan</option>
          <option value="02">Feb</option>
          <option value="03">Mar</option>
          <option value="04">Apr</option>
          <option value="05">May</option>
          <option value="06">Jun</option>
          <option value="07">Jul</option>
          <option value="08">Aug</option>
          <option value="09">Sep</option>
          <option value="10">Oct</option>
          <option value="11">Nov</option>
          <option value="12">Dec</option>
        </select>
        <select v-model="birthDay" :class="['pax-bday', {'has-error':error.fields.indexOf('birthDay') > -1}]" :disabled="loading">
          <option value="" disabled selected>Birth Day</option>
          <option v-for="x in 31" :value="leadingZero(x)" :key="x">{{leadingZero(x)}}</option>
        </select>
        <select v-model="birthYear" :class="['pax-bday', {'has-error':error.fields.indexOf('birthYear') > -1}]" :disabled="loading">
          <option value="" disabled selected>Birth Year</option>
          <option :value="currentYear">{{currentYear}}</option>
          <option v-for="x in 99" :value="currentYear - x" :key="x">{{currentYear - x}}</option>
        </select>
      </div>

      <div class="d-flex flex-field">
        <div :class="['pax-field', {'has-error':error.fields.indexOf('address') > -1}]">
          <input type="text" placeholder="Address" v-model="address" 
            autocomplete="one-time-code" :disabled="loading" />
        </div>
        <div :class="['pax-field', {'has-error':error.fields.indexOf('city') > -1}]">
          <input type="text" placeholder="City" v-model="city" 
            autocomplete="one-time-code" :disabled="loading" />
        </div>
      </div>
      <div class="d-flex flex-field">
        <div :class="['pax-field', {'has-error':error.fields.indexOf('zip') > -1}]">
          <input type="text" placeholder="Zip" v-model="zip" 
            autocomplete="one-time-code" :disabled="loading" />
        </div>
        <div :class="['pax-field', {'has-error':error.fields.indexOf('country') > -1}]">
          <select class="country-selector" v-model="country" placeholder="Country" :disabled="loading">
            <option value="" disabled selected>Select Country</option>
            <option v-for="(country, i) in countryList" :key="i" :value="country.code.toUpperCase()">{{cleanCountryName(country.name)}}</option>
          </select>
        </div>
      </div>

      <div class="pax-field">
        <input type="text" placeholder="Passport Number (Optional)" v-model="passportNum" autocomplete="one-time-code" />
      </div>

      <div :class="['pax-field', {'has-error':error.fields.indexOf('email') > -1}]">
        <input type="email" placeholder="Email" v-model="email"
          autocomplete="one-time-code" :disabled="loading" />
      </div>
      <div class="d-flex flex-field">
        <div :class="['pax-field', {'has-error':error.fields.indexOf('password') > -1}]">
          <input type="password" placeholder="Password" v-model="password"
            autocomplete="one-time-code" :disabled="loading" />
        </div>
        <div :class="['pax-field', {'has-error':error.fields.indexOf('rpassword') > -1}]">
          <input type="password" placeholder="Repeat Password" v-model="rpassword"
            autocomplete="one-time-code" :disabled="loading" />
        </div>
      </div>
      <div class="password-note">
        Leave password blank if you don't want to change your password.
      </div>

      <div class="error-msg" v-if="error.msg.length">
        <div v-for="(err, e) in error.msg" :key="e">- {{err}}</div>
      </div>

      <div class="op-btn btn-md btn-block btn-success update-btn" @click="processUpdate">
        <span>UPDATE PROFILE</span>
      </div>
      <div class="op-btn btn-md btn-block btn-secondary update-btn" @click="show = false" v-if="!forceUpdateProfile">
        <span>CLOSE</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import mobileInput from '@/components/D2DOthers/MobileInput'
const countries = require('@/data/countries')

export default {
  name: 'user-info',
  components: { mobileInput },
  data () {
    return {
      title: '',
      gender: '',
      firstName: '',
      lastName: '',
      birthMonth: '',
      birthDay: '',
      birthYear: '',
      address: '',
      city: '',
      zip: '',
      country: '',
      mobile: '',
      countryCode: 1,
      isVerified: false,
      passportNum: '',
      email: '',
      password: '',
      rpassword: '',
      error: {
        fields: [],
        msg: []
      },
      countryList: Object.values(countries),
      currentYear: parseInt(moment().format('YYYY')),
      loading: false
    }
  },
  computed: {
    user () { return this.$store.state.user },
    auth () { return this.$store.state.global.auth },
    userInfo () { return this.$store.state.global.userInfo },
    show: {
      get () { return this.userInfo.show },
      set (x) {
        this.$store.commit('global/setUserInfoData', {show: x})
      }
    },
    forceUpdateProfile () { return this.userInfo.forceUpdateProfile },
    isCorporate () { return this.user.isCorporate }
  },
  methods: {
    updateMobileInfo (val) {
      this.mobile = val.mobile
      this.countryCode = val.countryCode
      this.checkVerifiedAlready()
    },
    mobileVerified (val) {
      this.isVerified = val
    },
    checkVerifiedAlready () {
      if (this.userInfo.verifiedNumber.indexOf(`${this.countryCode}${this.mobile}`) > -1) {
        if (this.$refs.userMobile) {
          this.$refs.userMobile.alreadyVerified()
          this.isVerified = true
        }
      }
    },
    cleanCountryName (val) {
      let val2 = val.slice(0, val.indexOf(" ("))
      return val.indexOf(" (") === -1 ? val : val2
    },
    processUpdate () {
      let self = this
      if (self.loading) return
      self.$store.commit('global/setLoaderData', {show: true})
      self.checkVerifiedAlready()
      setTimeout(function () {
        self.update()
      }, 250)
    },
    update () {
      let self = this
      let hasError = false
      let fields = [
        'title', 'gender',
        'firstName', 'lastName', 'email',
        'birthMonth', 'birthDay', 'birthYear',
        'address', 'city', 'zip',
        'country', 'mobile'
      ]
      if (self.password || self.rpassword) {
        fields.push('password', 'rpassword')
      }
      self.error.fields = []
      self.error.msg = []
      fields.forEach(f => {
        if (!self[f]) {
          hasError = true
          self.error.fields.push(f)
        }
      })
      if (self.error.fields.length) {
        self.error.msg.push('Please fill up the missing fields.')
      }
      if (self.mobile && !self.isVerified) {
        hasError = true
        self.error.fields.push('mobile')
        self.error.msg.push('Phone verification is required.')
      }
      let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (self.email && !pattern.test(self.email)) {
        hasError = true
        self.error.msg.push(self.$t('common.invalidEmail'))
        self.error.fields.push('email')
      }
      let bday = ''
      if (self.birthDay && self.birthMonth && self.birthYear) {
        bday = moment(`${self.birthYear}-${self.birthMonth}-${self.birthDay}`, 'YYYY-MM-DD')
        if (!bday.isValid()) {
          bday = ''
          hasError = true
          self.error.msg.push('Invalid Birth Date')
          self.error.fields.push('birthMonth', 'birthDay', 'birthYear')
        }
      }
      if (self.password && self.password.length < 8) {
        hasError = true
        self.error.msg.push('Password must be at least 8 characters.')
      }
      if (self.rpassword && self.rpassword.length < 8) {
        hasError = true
        self.error.msg.push('Repeat password must be at least 8 characters.')
      }
      if (self.password && self.rpassword && self.password !== self.rpassword) {
        hasError = true
        self.error.msg.push(self.$t('customerForm.passwordNotMatch'))
      }
      if (hasError) {
        self.$store.commit('global/setLoaderData', {show: false})
        return
      }
      let tmp = {
        token: self.user.token,
        paxinfo: {
          title: self.title,
          gender: self.gender,
          address: self.address,
          city: self.city,
          zip: self.zip
        },
        firstName: self.firstName,
        lastName: self.lastName,
        email: self.email,
        mobile: `${self.countryCode}${self.mobile}`,
        phone: `+${self.countryCode}${self.mobile}`,
        countryCode: self.countryCode,
        nationalNumber: self.mobile,
        dateOfBirth: `${self.birthYear}-${self.birthMonth}-${self.birthDay}`,
        userCountry: self.country,
        passportNum: self.passportNum
      }
      self.loading = true
      self.$sdk.post(self, '/me', tmp, res => {
        if (res.error) {
          self.loading = false
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          })
          return
        }
        self.$store.commit('user/setUserData', {
          title: self.title,
          gender: self.gender,
          firstName: self.firstName,
          lastName: self.lastName,
          email: self.email,
          phone: {
            number: self.mobile,
            code: self.countryCode
          },
          bday: `${self.birthYear}-${self.birthMonth}-${self.birthDay}`,
          country: self.country,
          passportNum: self.passportNum
        })
        // self.updateAddress()
        if (self.password) {
          self.changePassword()
          return
        }
        self.$store.commit('global/setLoaderData', {show: false})
        self.$store.commit('global/setUserInfoData', {
          show: false,
          forceUpdateProfile: false
        })
        self.$store.commit('global/setAlertData', {
          show: true,
          message: 'Your profile has been updated successfully!'
        })
        if (self.auth.action) {
          self.$router.push(self.auth.action)
          self.$store.commit('global/setAuthData', {action: ''})
        }
      })
    },
    // updateAddress () {
    //   let self = this
    //   self.$sdk.post(self, '/me/locations', {
    //     token: self.user.token,
    //     address1: self.address,
    //     address2: '',
    //     zip: self.zip,
    //     state: '',
    //     city: self.city,
    //     lat: 0,
    //     lng: 0,
    //     type: 'home'
    //   }, res => {
    //     if (res.error) {
    //       self.loading = false
    //       self.$store.commit('global/setLoaderData', {show: false})
    //       self.$store.commit('global/setAlertData', {
    //         show: true,
    //         message: res.error.message
    //       })
    //       return
    //     }
    //     if (self.password) {
    //       self.changePassword()
    //       return
    //     }
    //     self.$store.commit('global/setLoaderData', {show: false})
    //     self.$store.commit('global/setUserInfoData', {show: false})
    //     self.$store.commit('global/setAlertData', {
    //       show: true,
    //       message: 'Your profile has been updated successfully!'
    //     })
    //   })
    // },
    changePassword () {
      let self = this
      self.$sdk.post(self, '/auth/password', {
        token: self.user.token,
        password: self.password,
        d2d: 1
      }, res => {
        self.loading = false
        self.$store.commit('global/setLoaderData', {show: false})
        let msg = 'Your profile has been updated successfully!'
        if (res.error) msg = res.error.message
        self.$store.commit('global/setAlertData', {
          show: true,
          message: msg
        })

        if (!res.error) {
          self.$store.commit('global/setUserInfoData', {show: false})
        }
      })
    },
    leadingZero (x) {
      x = x + ''
      return x.length === 1 ? '0' + x : x
    }
  },
  mounted () {
    this.title = this.user.title
    this.gender = this.user.gender
    if ([1, '1'].indexOf(this.user.gender) > -1) this.gender = 'Male'
    if ([2, '2'].indexOf(this.user.gender) > -1) this.gender = 'Female'
    this.firstName = this.user.firstName
    this.lastName = this.user.lastName
    this.mobile = this.user.phone.number
    this.countryCode = this.user.phone.code
    this.email = this.user.email
    if (this.user.bday) {
      let bday = moment(this.user.bday, 'YYYY-MM-DD')
      this.birthMonth = bday.format('MM')
      this.birthDay = bday.format('DD')
      this.birthYear = bday.format('YYYY')
    }
    this.address = this.user.address || ''
    this.city = this.user.city || ''
    this.zip = this.user.zip || ''
    this.country = this.user.country || ''
    this.passportNum = this.user.passportNum || ''

    if (this.user.phone.number && this.user.phone.code) {
      this.$store.commit('global/addVerifiedNumber', `${this.user.phone.code}${this.user.phone.number}`)
      this.isVerified = true
    }
    let firstVisit = localStorage.getItem('firstVisitData')
    if (firstVisit) {
      firstVisit = JSON.parse(firstVisit)
      this.$store.commit('global/addVerifiedNumber', `${firstVisit.countryCode}${firstVisit.mobile}`)
    }
    this.checkVerifiedAlready()
  }
}
</script>

<style lang="scss" scoped>
.user-info-modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0, .3);
  z-index: 2;
}
.user-info-box{
  background: #f9f9f9;
  border-radius: 4px;
  box-shadow: 2px 2px 4px rgba(0,0,0, .3);
  padding: 20px;
  width: 100%;
  max-width: 500px;
}

.page-title{
  font-size: 21px;
  font-weight: 600;
  padding: 0 0 15px;
  text-align: center;
}
.flex-field{
  gap: 10px;
  .pax-field{
    width: 50%;
  }
}
.pax-field{
  margin-bottom: 10px;

  input{
    padding: 10px;
    line-height: 1;
    box-shadow: inset 1px 1px 2px rgba(0,0,0,.1);
    border: 1px solid #ccc;
    width: 100%;
    outline: none;
  }
  &.has-error{
    border:1px solid #EB5837;
  }
  select{
    border-color: #ccc;
    border-radius: 0;
    line-height: 1;
    box-shadow: inset 1px 1px 2px rgba(0,0,0,.1);
    padding: 10px;
    &.has-error{
      border:1px solid #EB5837;
    }
  }
}

.password-note{
  font-size: 13px;
  line-height: 1.2;
  letter-spacing: .6px;
  color: #888;
  background: #eee;
  padding: 7px;
  border-left: 5px solid #ccc;
  font-style: italic;
  margin-bottom: 20px;
}

.error-msg{
  border: 1px solid #f00;
  background: #fadfdf;
  color: #f00;
  padding: 5px;
  line-height: 1.3;
  border-radius: 2px;
  margin: 10px 0 20px;
  text-align: left;

  a{
    color: #285cc7;
    font-weight: 600;
  }
}

.update-btn{
  letter-spacing: .7px;
  margin: 20px 0 0;
}

.btn-secondary{
  margin: 10px 0 0;
}
</style>



// WEBPACK FOOTER //
// UserInfo.vue?7c276cd6